/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'fire': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M33.781 27.201c.297 3.286-1.424 6.786-5.939 8.63.97-.894 2.025-2.268 2.001-4.112-.034-2.702-1.312-3.406-1.844-7.281-.438 3.094-6.781 5.172-6.781 8.484.045 1.023.319 2.365 1.013 2.972-3.508-.997-6.029-4.709-6.029-8.327 0-3.627 2.922-5.474 1.922-9.385 2.844.536 4.185 5.164 2.53 7.267 5.594-3.343 1.371-9.193 7.086-13.374-2.221 4.703 5.5 9.148 6.041 15.126z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/fire.js